import { render, staticRenderFns } from "./AdminSuper.vue?vue&type=template&id=6f30af18&lang=pug&"
import script from "./AdminSuper.vue?vue&type=script&lang=js&"
export * from "./AdminSuper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports